import React, { createContext, useContext, useMemo, useState } from 'react';

export type AnnexureFillingNavPayload = {
  variant: 'onboarding' | 'ongoing';
  setupHref: string;
  annexureLinks: { name: string; href: string }[];
};

type AnnexureFillingNavContextValue = {
  payload: AnnexureFillingNavPayload | null;
  setPayload: (p: AnnexureFillingNavPayload | null) => void;
};

const AnnexureFillingNavContext = createContext<AnnexureFillingNavContextValue | null>(null);

export function AnnexureFillingNavProvider({ children }: { children: React.ReactNode }) {
  const [payload, setPayload] = useState<AnnexureFillingNavPayload | null>(null);
  const value = useMemo(() => ({ payload, setPayload }), [payload]);
  return <AnnexureFillingNavContext.Provider value={value}>{children}</AnnexureFillingNavContext.Provider>;
}

/** Payload for sidebar merge when on an annexure filling page; `null` when not reporting. */
export function useAnnexureFillingNavOptional(): AnnexureFillingNavPayload | null {
  const ctx = useContext(AnnexureFillingNavContext);
  return ctx?.payload ?? null;
}

/** Safe to call outside provider (no-op). */
export function useAnnexureFillingNavSetPayload(): (p: AnnexureFillingNavPayload | null) => void {
  const ctx = useContext(AnnexureFillingNavContext);
  return ctx?.setPayload ?? (() => {});
}
